import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReAuth } from '@app/helpers/requests/createBaseQueryWithReAuth';

const baseQuery = createBaseQueryWithReAuth();
export const bennieApi = createApi({
  reducerPath: 'bennieApi',
  baseQuery,
  endpoints: () => ({}),
});
